<template>
  <div>
    <div>
      <div
        style="
          background-color: #f7f8fa;
          font-size: 16px;
          line-height: 38px;
          font-weight: 600;
        "
      >
        填写发票抬头
      </div>
      <van-form ref="form" :model="formData" @submit="onSubmit">
        <div
          style="
            margin-top: 20px;
            text-align: start;
            font-size: 16px;
            line-height: 38px;
            font-weight: 600;
            padding-left: 10px;
          "
        >
          发票接收信息
        </div>
        <van-field
          v-model="formData.buyerPhone"
          label="手机号"
          name="buyerPhone"
          placeholder="请输入手机号"
          clearable
          :rules="[
            { required: true, message: '' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' },
          ]"
        ></van-field>
        <van-field
          v-model="formData.email"
          label="邮箱"
          name="email"
          placeholder="请输入邮箱"
          clearable
          :rules="[
            { required: true, message: '' },
            {
              pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
              message: '请输入正确的邮箱地址',
            },
          ]"
        ></van-field>
        <div
          style="
            margin-top: 20px;
            text-align: start;
            font-size: 16px;
            line-height: 38px;
            font-weight: 600;
            padding-left: 10px;
          "
        >
          发票信息
        </div>
        <div style="display: flex; align-items: center">
          <div
            style="
              font-size: 15px;
              padding-left: 16px;
              color: #646566;
              margin-right: 34px;
              line-height: 40px;
            "
          >
            发票类型
          </div>
          <div style="display: flex; font-size: 15px">
            <div
              class="btn"
              :class="formData.invoiceLine == 'bs' ? 'selectInvoice' : ''"
              @click="changeInvoiceType('bs')"
            >
              专用发票
            </div>
            <div
              class="btn"
              :class="formData.invoiceLine == 'pc' ? 'selectInvoice' : ''"
              style="margin-left: 20px"
              @click="changeInvoiceType('pc')"
            >
              普通发票
            </div>
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <div
            style="
              font-size: 15px;
              padding-left: 16px;
              color: #646566;
              margin-right: 34px;
              line-height: 40px;
            "
          >
            抬头类型
          </div>
          <div style="display: flex; font-size: 15px">
            <div
              class="btn"
              :class="formData.Type == 0 ? 'selectStyle' : ''"
              @click="changeType(0)"
            >
              个人
            </div>
            <div
              class="btn"
              :class="formData.Type == 1 ? 'selectStyle' : ''"
              style="margin-left: 20px"
              @click="changeType(1)"
            >
              单位
            </div>
          </div>
        </div>
        <div v-if="formData.Type == 0">
          <van-field
            v-model="formData.buyerName"
            label="发票抬头"
            name="buyerName"
            placeholder="请输入发票抬头"
            clearable
            :rules="[{ required: true, message: '' }]"
          ></van-field>
        </div>
        <div v-else>
          <van-field
            v-model="formData.buyerName"
            label="发票抬头"
            name="buyerName"
            placeholder="请输入发票抬头"
            clearable
            :rules="[{ required: true, message: '' }]"
          ></van-field>
          <van-field
            v-model="formData.buyerTaxNum"
            label="单位税号"
            name="buyerTaxNum"
            placeholder="请输入单位税号"
            clearable
            :rules="[{ required: true, message: '' }]"
          ></van-field>
          <van-field
            v-model="formData.buyerAddress"
            label="注册地址"
            name="buyerAddress"
            placeholder="请输入注册地址"
            clearable
          ></van-field>
          <van-field
            v-model="formData.buyerTel"
            label="注册电话"
            name="buyerTel"
            placeholder="请输入注册电话"
            clearable
          ></van-field>
          <van-field
            v-model="formData.buyerBank"
            label="注册银行"
            name="buyerBank"
            placeholder="请输入注册银行"
            clearable
          ></van-field>
          <van-field
            v-model="formData.buyerAccount"
            label="银行账号"
            name="buyerAccount"
            placeholder="请输入银行账号"
            clearable
          ></van-field>
        </div>

        <button
          type="info"
          native-type="submit"
          style="
            background: #4088ff;
            width: 90%;
            border: none;
            color: #fff;
            line-height: 40px;
            font-size: 16px;
            border-radius: 26px;
            margin-top: 30px;
          "
        >
          确认
        </button>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      formData: {
        buyerPhone: '',
        email: '',
        carParkId: '',
        Type: '1',
        buyerName: '',
        buyerTaxNum: '',
        buyerAddress: '',
        buyerTel: '',
        buyerBank: '',
        buyerAccount: '',
        invoiceLine: 'bs'
      }
    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created () {
    if (sessionStorage.getItem('formData')) {
      this.formData = JSON.parse(sessionStorage.getItem('formData'))
    } else {
      this.formData.carParkId = this.$route.params.id
    }
  },
  mounted () {

  },
  methods: {
    changeInvoiceType (str) {
      this.formData.invoiceLine = str
    },
    changeType (type) {
      this.formData.Type = type
      // 当切换发票类型时清空抬头信息
      this.formData.buyerName = ''
    },
    onSubmit () {
      // 保存表单数据到 sessionStorage
      sessionStorage.setItem('formData', JSON.stringify(this.formData));
      this.$router.push({
        name: "invoiceSearch",
        params: this.formData
      })
    },
  },
};
</script>

<style scoped lang="less">
.btn {
  //   width: 73px;
  padding: 0 15px;
  height: 28px;
  line-height: 28px;
  border-radius: 26px;
  border: 1px solid #86909c;
}
.selectStyle {
  background: #4088ff;
  color: #fff;
  border: none;
}
.selectInvoice {
  background: #4088ff;
  color: #fff;
  border: none;
}
</style>
